import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatAnchor } from '@angular/material/button';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { NavigationRoute } from '@app/models';
import { NavService } from '@app/services';
import { Observable } from 'rxjs';

@Component({
  selector: 'qb-subnav-menu',
  templateUrl: './subnav-menu.component.html',
  styleUrls: ['./subnav-menu.component.scss'],
  imports: [MatAnchor, RouterLinkActive, RouterLink, AsyncPipe],
  providers: [],
})
export class SubnavMenuComponent {
  protected navService: NavService = inject(NavService);

  routes: Observable<NavigationRoute[]>;

  constructor(private router: Router) {
    this.routes = this.navService.$subnavRoutes;
  }

  itemChanged() {
    this.navService.onNavChanged();
  }
}
